import { GetStaticPropsContext } from 'next';
import SeoHead from '@/shared/components/seo-head/seo-head';
import pick from '@/utils/translation/pick';
import NotFoundPage from '@/modules/not-found-page/not-found-page';
import { useTranslations } from 'next-intl';

const NotFound = () => {
  const t = useTranslations('NotFound');

  return (
    <>
      <SeoHead title={t('metaTitle')} description={t('metaDescription')} />

      <NotFoundPage />
    </>
  );
};

export default NotFound;

export async function getStaticProps({ locale }: GetStaticPropsContext) {
  const messages = ['Common', 'NotFound'];
  return {
    props: {
      messages: pick((await import(`src/intl/${locale}.js`)).default, messages),
    },
  };
}
